<div
  *ngIf="user; else nouser"
  [nbPopover]="popover"
  [nbPopoverTrigger]="'hover'"
  [nbPopoverPlacement]="'bottom'">
  {{user.firstName}} {{user.lastName}} ({{user.abbreviation}})
</div>

<ng-template #nouser>
  <div class="no-user">kein Benutzer</div>
</ng-template>

<ng-template #popover>
  <wr-user-popover [user]="user" [disableLink]="disableLink"></wr-user-popover>
</ng-template>
